import {Injectable, signal, WritableSignal} from '@angular/core';
import {IControlObject} from 'frontier';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  languageAlertObjects: WritableSignal<IControlObject[]> = signal<IControlObject[]>([]);
  invoiceAlertObjects: WritableSignal<IControlObject[]> = signal<IControlObject[]>([]);
  dunningAlertObjects: WritableSignal<IControlObject[]> = signal<IControlObject[]>([]);
}
